import WINDOW from "../../../utils/window";

/**
 * Get bounds from DOMrect
 * @param {DOMRect} bounds
 * @param {Number} ratio
 * @returns {BoundsProps}
 */
const getBoundsMap = (bounds, ratio = 1) => {
  /** @type {BoundsProps} */
  const result = new Map();

  const scrollLeft =
    /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll")).get("x") || 0;

  const scrollTop =
    /** @type {WindowCoordinatesProps} */ (WINDOW.get("scroll")).get("y") || 0;

  const windowWidth = /** @type {Number} */ (WINDOW.get("width"));

  const bottomRef = bounds.y * ratio + bounds.height * ratio;

  const rightRef = bounds.x * ratio + bounds.width * ratio;

  result.set("rect", bounds);
  result.set("width", bounds.width * ratio);
  result.set("height", bounds.height * ratio);
  result.set("top", bounds.y * ratio);
  result.set("left", bounds.x * ratio);
  result.set("right", bounds.right || rightRef);
  result.set("bottom", bounds.bottom || bottomRef);
  result.set("offset-left", bounds.x * ratio + scrollLeft);
  result.set("offset-right", windowWidth - rightRef - scrollLeft);
  result.set("offset-top", bounds.y * ratio + scrollTop);
  result.set("offset-bottom", bottomRef + scrollTop);
  result.set("center-x", bounds.x * ratio + (bounds.width * ratio) / 2);
  result.set("center-y", bounds.y * ratio + (bounds.height * ratio) / 2);
  result.set("viewport-top", bounds.top);
  result.set("viewport-right", windowWidth - bounds.right);
  result.set("viewport-bottom", bounds.bottom);
  result.set("viewport-left", bounds.left);

  const offsetLeft = /** @type {Number} */ (result.get("offset-left"));
  const offsetTop = /** @type {Number} */ (result.get("offset-top"));
  const width = /** @type {Number} */ (result.get("width"));
  const height = /** @type {Number} */ (result.get("height"));

  result.set("middle-x", offsetLeft + width / 2);
  result.set("middle-y", offsetTop + height / 2);

  return result;
};

export default getBoundsMap;
